export default __webpack_public_path__ + "static/media/a4.97ef96a7.png";